export enum CertificationStatus {
  ALL = "All",
  PENDING = "Pending",
  DENIED = "Denied",
  APPROVED = "Approved",
}
